import { atom, selector } from "recoil";
import { PreferencesType } from "../../types/account/type";
import { getLocalPreference, setLocalPreference } from "../../services/preference/localStorage";
import { inProgressSpaceListState } from "../spaces/inProgressSpaceListState";
import { getAllSpaceIds } from "../../services/space/space.service";

/**
 * 초기값을 위한 selector
 * selectedSpaceIds가 []이면 전체 리스트로 설정하기 위한 로직
 */
export const initialPreferenceSelector = selector({
  key: "initialPreferenceSelector",
  get: ({ get }) => {
    const inProgressSpaceList = get(inProgressSpaceListState) || [];
    const onlyInProgressSpaceIds = getAllSpaceIds(inProgressSpaceList);

    const localPreference = getLocalPreference();

    // selectedSpaceIds가 없거나 빈 배열이면 전체 리스트로 설정
    if (!localPreference?.selectedSpaceIds || localPreference.selectedSpaceIds.length === 0) {
      return {
        ...localPreference,
        selectedSpaceIds: onlyInProgressSpaceIds,
      };
    }

    return localPreference;
  },
});

export const preferenceState = atom<PreferencesType>({
  key: "preferenceState",
  default: initialPreferenceSelector, // selector를 default로 사용
  effects: [
    ({ onSet }) => {
      onSet((newValue) => {
        setLocalPreference(newValue);
      });
    },
  ],
});
